/**
 * URL for the Sisu Forge hub (product tiles). On `travelbuddy.*` hosts the SPA has no `/` hub, so we derive the apex domain.
 * Override with `REACT_APP_SISUFORGE_HUB_URL` when needed (e.g. custom CDN).
 */
export function getSisuForgeHubHref(): string {
  const fromEnv = process.env.REACT_APP_SISUFORGE_HUB_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h.startsWith('travelbuddy.')) {
      const rootHost = h.slice('travelbuddy.'.length);
      return `${window.location.protocol}//${rootHost}`;
    }
  }
  return '/';
}

export function isSisuForgeHubExternal(href: string): boolean {
  return href.startsWith('http://') || href.startsWith('https://');
}
